import { QUOTE_PRODUCT_ID } from '@vertex-protocol/contracts';
import { PRIMARY_QUOTE_SYMBOLS } from '../primaryQuoteSymbols';
import { SpotProductMetadata } from '../types';
import {
  KBTC_INK,
  KBTC_INK_TESTNET,
  USDC_INK,
  USDC_INK_TESTNET,
  USDT0_INK,
  USDT0_INK_TESTNET,
  WETH_INK,
  WETH_INK_TESTNET,
  WQQQX_INK,
  WQQQX_INK_TESTNET,
  WSPYX_INK,
  WSPYX_INK_TESTNET,
} from './tokens';

/**
 * Ink Mainnet
 * Quote token is USDT0 (USD₮0), verified on-chain via spotEngine.getToken(0).
 */
export const INK_SPOT_METADATA_BY_PRODUCT_ID: Record<number, SpotProductMetadata> = {
  [QUOTE_PRODUCT_ID]: {
    token: USDT0_INK,
    marketName: '',
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot']),
  },
  // Product ID 1 = kBTC spot market (Kraken wrapped BTC)
  1: {
    token: KBTC_INK,
    marketName: `kBTC-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'chain']),
  },
  // Product ID 3 = wETH spot market
  3: {
    token: WETH_INK,
    marketName: `wETH-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'chain']),
  },
  // Product ID 5 = USDC (Circle native, CCTP-bridged)
  5: {
    token: USDC_INK,
    marketName: `USDC-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot']),
  },
  // Product ID 115 = wrapped QQQ xStock spot market
  115: {
    token: WQQQX_INK,
    marketName: `wQQQx-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'index']),
  },
  // Product ID 117 = wrapped SPY xStock spot market
  117: {
    token: WSPYX_INK,
    marketName: `wSPYx-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'index']),
  },
};

/**
 * Ink Testnet
 */
export const INK_TESTNET_SPOT_METADATA_BY_PRODUCT_ID: Record<number, SpotProductMetadata> = {
  [QUOTE_PRODUCT_ID]: {
    token: USDT0_INK_TESTNET,
    marketName: '',
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot']),
  },
  1: {
    token: KBTC_INK_TESTNET,
    marketName: `kBTC-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'chain']),
  },
  3: {
    token: WETH_INK_TESTNET,
    marketName: `wETH-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'chain']),
  },
  5: {
    token: USDC_INK_TESTNET,
    marketName: `USDC-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot']),
  },
  115: {
    token: WQQQX_INK_TESTNET,
    marketName: `wQQQx-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'index']),
  },
  117: {
    token: WSPYX_INK_TESTNET,
    marketName: `wSPYx-${PRIMARY_QUOTE_SYMBOLS.usdt0}`,
    quoteProductId: QUOTE_PRODUCT_ID,
    marketCategories: new Set(['spot', 'index']),
  },
};
